module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/heart-866d180dc63f4603d0e7fdd3b0d04f09.png";